import { GetTransactionArgs } from 'types/api/arguments/get-transaction-args'
import { GetTransactionResp } from 'types/api/response/get-transaction-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getTransaction = ({ id }: GetTransactionArgs) =>
  api.get<GetTransactionResp>(`/transactions/${id}`, { headers: moneyObjectHeader })
